/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/auto-forecast-policy-settings';

export const AutoForecastPolicySettingApi = {
  filter: async (option: FilterAutoForecastPolicySettingOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteMulti: async (body: DeleteMultiAutoForecastPolicySettingBody) => {
    const url = `${pathname}/delete/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: CreateMultiAutoForecastPolicySettingBody) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateAutoForecastPolicySettingBody {
  autoForecastSettingDetailItemID: string;
  entityPricePolicyID?: string;
  entityProposalPolicyID?: string;
}

export interface CreateMultiAutoForecastPolicySettingBody {
  autoForecastPolicySettings: CreateAutoForecastPolicySettingBody[];
}

export interface DeleteMultiAutoForecastPolicySettingBody {
  autoForecastPolicySettingIDs: string[];
}

export type AutoForecastPolicySetting = {
  id: string;
  entityProposalPolicy?: any;
  entityPricePolicy?: any;
  entityProposalPolicyID?: string;
  entityPricePolicyID?: string;
};

export interface FilterAutoForecastPolicySettingOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  status?: number;
  autoForecastSettingDetailItemID?: string;
}
